import { makeRecordThumbnailHook } from '@akin-home/images/react';
import useRecordImage from './useRecordImage';

/** Localised version of useRecordThumbnail that hooks into device assets folder */
const useRecordThumbnail = makeRecordThumbnailHook(useRecordImage);

export default useRecordThumbnail;
